import { userRoles } from "./enums/user-roles.js";

export default {
  login(token, refreshToken, expiresIn) {
    localStorage.token = token;
    localStorage.refreshToken = refreshToken;
    localStorage.expiresIn = Math.round(new Date() / 1000) + expiresIn;
  },
  logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    localStorage.removeItem("expiresIn");
  },
  loggedIn() {
    return !!localStorage.token;
  },
  setUser(user) {
    localStorage.user = JSON.stringify(user);
  },
  getToken() {
    return localStorage.token;
  },
  getRefreshToken() {
    return localStorage.refreshToken;
  },
  getUser() {
    return JSON.parse(localStorage.user);
  },
  tokenIsExpired() {
    return localStorage.expiresIn - Math.round(new Date() / 1000) <= 0;
  },
  isAdmin() {
    const user = this.getUser();
    if (!user) {
      return false;
    }
    return !!user.roles.find(i => i.id === userRoles.Admin);
  },
  isClientManager() {
    const user = this.getUser();
    if (!user) {
      return false;
    }
    return !!user.roles.find(i => i.id === userRoles.ClientManager);
  },
  isLogist() {
    const user = this.getUser();
    if (!user) {
      return false;
    }
    return !!user.roles.find(i => i.id === userRoles.Logist);
  },
};
